import PrinterTimeTable from "../PrinterTimeTable";

type Props = {};

const PrinterPage = ( props: Props ) => {

	return (
		<div className="flex-1">
			<PrinterTimeTable />
		</div>
	);
};

export default PrinterPage;
